export enum ExpiryStatus {
	TODAY = 'TODAY',
	TOMORROW = 'TOMORROW',
	LATER = 'LATER',
	EXPIRED = 'EXPIRED'
}
